<div class="downtime-modal">
  <div class="downtime-modal__header">
    <div class="downtime-modal__header-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#e65100"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" y1="15" x2="12" y2="3" />
      </svg>
    </div>
    <h2 class="downtime-modal__title">Update your app</h2>
    <button
      type="button"
      class="downtime-modal__close downtime-modal__close--x"
      (click)="skip()"
      aria-label="Skip"
    >
      <span class="downtime-modal__close-x" aria-hidden="true">×</span>
    </button>
  </div>

  <p class="downtime-modal__subtitle">Dear Merchants &amp; Owners</p>

  <p class="downtime-modal__desc">
    Please update EasyEat Partner to the latest version
    <strong>{{ requiredVersion }}</strong>
    to keep orders, payments, and printing working reliably.
  </p>

  <div class="downtime-modal__time-block">
    <div class="downtime-modal__time-row">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#1742ff"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" y1="15" x2="12" y2="3" />
      </svg>
      <span class="downtime-modal__time-text"
        >Latest app version: {{ requiredVersion }}</span
      >
    </div>
  </div>

  <div class="downtime-modal__warning" role="alert">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#bf360c"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
    <span>
      You will be logged out when you proceed. Finish or cancel any open orders
      first so they are not misplaced, and so no leftover session stays active.
    </span>
  </div>

  <div class="downtime-modal__actions">
    <button
      type="button"
      class="downtime-modal__btn downtime-modal__btn--secondary"
      (click)="skip()"
    >
      Skip
    </button>
    <button
      type="button"
      class="downtime-modal__btn downtime-modal__btn--primary"
      (click)="proceedToStore()"
    >
      Proceed
    </button>
  </div>
</div>
